import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
    selector: 'app-toolbar-search',
    templateUrl: './toolbar-search.component.html',
    styleUrls: ['./toolbar-search.component.scss'],
    standalone: false
})
export class ToolbarSearchComponent implements OnInit {


  isOpen: boolean = false;

  @ViewChild('input', { read: ElementRef, static: true }) input: ElementRef | undefined;

  constructor() {
  }

  ngOnInit() {
  }

  open() {
    this.isOpen = true;

    setTimeout(() => {
      if(this.input) {
        this.input.nativeElement.focus();
      }
    }, 100);

  }

  close() {
    this.isOpen = false;
  }


}
